import React from "react";

const FloatingButtons = () => {
  return (
    <div className="floating-buttons">
      <a href="tel:+919643532525" className="floating-btn call">
        <i className="zmdi zmdi-phone"></i>
        <span>Call</span>
      </a>

      <a
        href="https://wa.me/919643532525"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn whatsapp"
      >
        <i className="zmdi zmdi-whatsapp"></i>
        <span>WhatsApp</span>
      </a>

      <a
        href="https://maps.app.goo.gl/JM2UiFLdbifgxptP8?g_st=aw"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn map"
      >
        <i className="zmdi zmdi-pin"></i>
        <span>Map</span>
      </a>
    </div>
  );
};

export default FloatingButtons;